
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_4915_17840)"}},[_c('path',{attrs:{"d":"M23.995 10.668c0-4.413-3.587-8-8-8s-8 3.587-8 8c0 6 8 14.667 8 14.667s8-8.667 8-14.667zm-10.667 0c0-1.467 1.2-2.667 2.667-2.667a2.666 2.666 0 11-2.667 2.667zm-6.666 16v1.333h18.666v-1.333H6.662z","fill":"currentColor"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_4915_17840"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h32v32H0z"}})])])])
          )
        }
      }
    